import { useNotification } from "app/NotificationProvider";
import { analytics, AnalyticsEvents } from "common/analytics";
import EventFileUpload from "common/components/EventFileUpload";
import EventFormDialog from "common/components/EventFormDialog";
import { useTranslation } from "common/locales";
import { FertilizerEvent, useUpdateFertilizerEvent } from "model";
import { Dispatch, SetStateAction, useRef } from "react";

import EnterFertilizerEvent from "./EnterFertilizerEvent";
import {
  convertFromFormInput,
  FertilizerEventFormData,
} from "./FertilizerEventFormData";

export default function UpdateFertilizerEvent({
  fertilizerEvent,
  dialogOpen,
  setDialogOpen,
}: {
  fertilizerEvent: FertilizerEvent;
  dialogOpen: boolean;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}) {
  const { notify } = useNotification();
  const { t } = useTranslation();
  const updateFertilizerEventMutation = useUpdateFertilizerEvent();
  const dirtyRef = useRef(false);

  const handleClose = () => {
    setDialogOpen(false);
  };

  async function handleSave(
    fertilizerEventFormData: FertilizerEventFormData,
    farmGuid: string | undefined
  ) {
    const fertilizerEventBody = convertFromFormInput(fertilizerEventFormData);
    await updateFertilizerEventMutation.mutateAsync({
      fertilizerEvent: { ...fertilizerEvent, ...fertilizerEventBody },
    });
    notify(t("updateFertilizerEvent.add.success"));
    analytics.track(AnalyticsEvents.FERTILIZER_EVENT_UPDATED);
    handleClose();
  }
  return (
    <EnterFertilizerEvent
      fertilizerEvent={fertilizerEvent}
      handleSave={handleSave}
      fieldSelectDisabled={false}
      dirtyRef={dirtyRef}
      fileUploadSlot={<EventFileUpload farmEventGuid={fertilizerEvent.guid} />}
    >
      {({ steps, submitForm }) => (
        <EventFormDialog
          open={dialogOpen}
          onClose={handleClose}
          title={t("fertilizerEventInput.title")}
          onSave={submitForm}
          isDirty={() => dirtyRef.current}
          cancelAnalyticsEvent={
            AnalyticsEvents.FERTILIZER_EVENT_UPDATE_CANCELLED
          }
          steps={steps}
        />
      )}
    </EnterFertilizerEvent>
  );
}
